function nonEmptyString(value) {
  return typeof value === 'string' && value.trim() ? value : null;
}

/**
 * Classify an SDK jobCompleted payload without consulting `imageUrl`, whose
 * SDK getter falls back to previewUrl when no downloadable result exists.
 */
export function classifyJobCompletion(job, { allowNSFWResult = false } = {}) {
  const status = String(job?.status || '').toLowerCase();
  const isNSFW =
    job?.isNSFW === true ||
    job?.triggeredNSFWFilter === true ||
    job?.isNSFWFiltered === true;
  const isCanceled =
    job?.userCanceled === true || status === 'canceled' || status === 'cancelled';

  if (isNSFW && !allowNSFWResult) {
    return {
      success: false,
      error: 'Filtered (NSFW)',
      code: 'NSFW_FILTERED',
      isNSFWFiltered: true
    };
  }

  if (isCanceled) {
    return {
      success: false,
      error: 'Image generation was canceled',
      code: 'IMAGE_CANCELED',
      isNSFWFiltered: false
    };
  }

  const resultUrl = nonEmptyString(job?.resultUrl);
  if (!resultUrl) {
    return {
      success: false,
      error: 'Image generation completed without a downloadable result',
      code: 'IMAGE_RESULT_MISSING',
      isNSFWFiltered: false
    };
  }

  // The server's advisory label on a delivered result (the filter was off,
  // nothing was withheld); viewers decide whether to cover it.
  return { success: true, resultUrl, ...(jobSensitive(job) ? { sensitive: true } : {}) };
}

/**
 * A delivered SDK job the server labelled sensitive: `nsfwDetected` on current
 * frames, or the legacy withhold flag (exposed by the SDK as `isNSFW`) left on
 * a frame that was still delivered because the filter was off.
 */
export function jobSensitive(job) {
  return job?.nsfwDetected === true || job?.isNSFW === true;
}
